export default "__VITE_ASSET__BI0hJJw5__"